import { render, staticRenderFns } from "./BlockAdmins.vue?vue&type=template&id=70cd35a6&scoped=true&"
import script from "./BlockAdmins.vue?vue&type=script&lang=js&"
export * from "./BlockAdmins.vue?vue&type=script&lang=js&"
import style0 from "./BlockAdmins.vue?vue&type=style&index=0&id=70cd35a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd35a6",
  null
  
)

export default component.exports